export const TEST_ID = 'termsOfServicePage';
